module.exports = __webpack_public_path__ + "static/awards-03-71e99747d5857619dca0cc351caebd81.png";